import { NgModule } from "@angular/core";
import { CircCommonModule } from "../common/common.module";
import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { AdminRoutingModule } from "./admin-routing.module";
import { EditSettingComponent } from "./settings/edit-settings/edit-setting.component";
import { SettingsComponent } from "./settings/settings.component";

@NgModule({
  declarations: [
    AdminDashboardComponent,
    SettingsComponent,
    EditSettingComponent
  ],
  imports: [CircCommonModule, AdminRoutingModule]
})
export class AdminModule {}
